import React from "react";
import "react-lazy-load-image-component/src/effects/opacity.css";
import vupopforfans1 from "../assets/vupopforfans1.png";
import vupopforfans2 from "../assets/vupopforfans2.png";
import vupopforfans3 from "../assets/vupopforfans3.png";
import vupopforfans4 from "../assets/vupopforfans4.png";
import vupopforfans5 from "../assets/vupopforfans5.png";

const VFF_fanFeatures = () => {
  return (
    <section className="w-full bg-black ">
      <div className="w-full px-4 sm:px-6 lg:px-8 sm:py-12 md:py-16 lg:py-20 xl:py-24">
        <div className="mx-auto w-full px-8 xl:px-7 lg:px-7 md:px-4 sm:px-0 space-y-12 lg:space-y-20">
          {/* ROW 1 */}
          <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">
            {/* Card */}
            <div className="w-full bg-[#111315] rounded-3xl overflow-hidden flex flex-col">
              <div className="" />

              <img
                src={vupopforfans1}
                alt="Vupop for Fans"
                className="w-[70%] lg:w-full mx-auto lg:mx-0 h-auto object-contain"
              />

              <div className="p-6 lg:p-5 md:p-4 sm:p-4">
                {/* <span className="text-[#FFF528] font-[Inter] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] uppercase">
    Tag 1
  </span> */}

                <h3 className="text-[#F1F1EF] font-[Norwester] text-[22px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[15px] uppercase mt-3 leading-tight">
                  Share the Way You See Sport
                </h3>

                <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                  No fancy equipment. No editing studio. Just your phone and
                  your passion. Vupop gives you a simple place to upload your
                  match day moments and show what the game really feels like
                  from the stands, from the pub or from home.
                </p>
              </div>
            </div>

            {/* Card */}
            <div className="w-full bg-[#111315] rounded-3xl overflow-hidden flex flex-col">
              <div className="" />
              <img
                src={vupopforfans2}
                alt="Vupop for Fans"
                className="w-[70%] lg:w-full mx-auto lg:mx-0 h-auto object-contain"
              />

              <div className="p-6 lg:p-5 md:p-4 sm:p-4">
                {/* <span className="text-[#FFF528] font-[Inter] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] uppercase">
              Tag 2
            </span> */}

                <h3 className="text-[#F1F1EF] font-[Norwester] text-[22px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[15px] uppercase mt-3 leading-tight">
                  Be Part of the Sports Story
                </h3>

                <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                  Vupop helps fan videos and supporter reactions reach sports
                  media teams, clubs and brands. When you join Vupop, you give
                  permission through our terms and conditions for your content
                  to be used. This lets your clips become part of sports
                  coverage without extra steps or delays.
                </p>
              </div>
            </div>
          </div>

          {/* ROW 2 SPLIT */}
          <div className="w-full mx-auto">
            <div className="w-full bg-[#111315] rounded-3xl overflow-hidden">
              <div className="flex flex-row lg:flex-row xl:flex-row md:flex-row sm:flex-col">
                {/* LEFT SIDE */}
                <div className="w-full sm:w-full lg:w-1/2 flex flex-col justify-center p-6 lg:p-5 md:p-4 sm:p-4">
                  {/* <span className="text-[#FFF528] font-[Inter] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] uppercase">
          Tag 3
        </span> */}

                  <h2 className="text-[#F1F1EF] font-[Norwester] text-[22px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[15px] uppercase mt-3 leading-tight">
                    Grow as a Sports Creator
                  </h2>

                  <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                    Some fans become sports creators without even trying. A
                    great celebration or a funny reaction can reach thousands of
                    people online. Vupop helps you:
                  </p>

                  <ul className="mt-6 space-y-3 text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px]  leading-relaxed list-disc pl-6">
                    <li>Share your best content</li>
                    <li>Gain recognition from the community</li>
                    <li>Connect with fans and creators</li>
                    <li>Get seen by sports and media brands</li>
                  </ul>

                  <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                    If you love filming matches or capturing atmosphere, Vupop
                    is made for you.
                  </p>
                </div>

                {/* RIGHT SIDE */}
                {/* <div className="w-full lg:w-1/2 relative min-h-[550px]">  */}
                <div className="w-full lg:w-1/2 relative sm:w-full">
                  <img
                    src={vupopforfans3}
                    alt="Vupop for Fans"
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ROW 3 */}
          <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">
            <div className="w-full bg-[#111315] rounded-3xl overflow-hidden flex flex-col">
              <div className="" />
              <img
                src={vupopforfans4}
                alt="Vupop for Fans"
                className="w-[70%] lg:w-full mx-auto lg:mx-0 h-auto object-contain"
              />

              <div className="p-6 lg:p-5 md:p-4 sm:p-4">
                {/* <span className="text-[#FFF528] font-[Inter] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] uppercase">
              Tag 4
            </span> */}

                <h3 className="text-[#F1F1EF] font-[Norwester] text-[22px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[15px] uppercase mt-3 leading-tight">
                  Show Real Emotion and Energy
                </h3>

                <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                  Sport is more than highlights. It is drama, fear, joy and
                  heartbreak. Professional cameras show the game. Fans show the
                  feeling. This is why fan content is becoming such a big part
                  of sports media today.
                </p>
              </div>
            </div>

            <div className="w-full bg-[#111315] rounded-3xl overflow-hidden flex flex-col">
              {/* <div className="w-full h-56 sm:h-64 md:h-72 bg-gradient-to-b from-[#8B8B8B33] to-[#111315]" /> */}
              <div className="" />
              <img
                src={vupopforfans5}
                alt="Vupop for Fans"
                className="w-[70%] lg:w-full mx-auto lg:mx-0 h-auto lg:h-[100%] object-contain lg:object-auto"
              />

              <div className="p-6 lg:p-5 md:p-4 sm:p-4">
                {/* <span className="text-[#FFF528] font-[Inter] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] uppercase">
              Tag 5
            </span> */}

                <h3 className="text-[#F1F1EF] font-[Norwester] text-[22px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[15px] uppercase mt-3 leading-tight">
                  Why Fans Use Vupop
                </h3>

                <p className="text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed">
                  In 2026, authenticity matters more than ever. Real fan content
                  makes sport feel human again.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VFF_fanFeatures;
